// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4497":"css/app.6968","8989":"css/admin-app.6968"}[chunkId] + ".css";
};